// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__llmpf","title":"InfoRow_title__gX7UI"};